export default __webpack_public_path__ + "static/media/notification-bell.992fb559.svg";